import { createDecorator } from '../../instantiation/common/instantiation.js';
const IFileService = ( createDecorator('fileService'));
export { IFileService };
